import { NavigationProjectFeedEntry } from '../project-feed/project-feed.model';

export function transformUserRecentProjectsAndContests(
  listItem: any,
): NavigationProjectFeedEntry {
  return {
    ...listItem,
    urlPart:
      listItem.type === 'project'
        ? `/projects/${listItem.urlPart}`
        : listItem.urlPart,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/navigation/recent-projects-and-contests/recent-project-and-contests.transformers.ts